module.exports = __webpack_public_path__ + "img/PORSCHE.1fe9232.jpg";